<div class="bar"
     [class.mat-elevation-z2]="2>1 || hasScrolled"
     [class.has-side-menu]="hasSideMenu">
    <div class="left"
         [class.logo-hideable]="!logoAlwaysDisplayed">
        <img class="logo"
             [src]="conf.assetsUrl + 'img/header-logo.png'"
             [routerLink]="dashboardUrl"  alt="logo"/>
        <img class="logo-compact"
             [src]="conf.assetsUrl + 'img/header-logo-compact.png'"
             [routerLink]="dashboardUrl"  alt="logo compact"/>
    </div>
    <div class="right">
        <header-main-menus></header-main-menus>
        <app-chat-discussion-list  [organization]="organization"></app-chat-discussion-list>
        <notifications-notifications-menu></notifications-notifications-menu>
        <button mat-mini-fab
                class="fab"
                [matTooltip]="'Account' | translate"
                [matMenuTriggerFor]="userMenu">
            <mat-icon color="primary">person_outline</mat-icon>
        </button>
        <mat-menu class="user-menu"
                  xPosition="before"
                  #userMenu="matMenu">
            <button mat-menu-item
                    class="menu-button avatar-button"
                    [routerLink]="'/users/' + currentUser.user?.id + '/edit'">
                <mat-icon *ngIf="!currentUser.user?.avatar">person</mat-icon>
                <img *ngIf="currentUser.user?.avatar"
                     [src]="conf.storageRootUrl + currentUser.user?.avatar"
                     class="avatar"  alt=" "/>
                {{ 'My_account' | translate }}
            </button>
<!--            <button mat-menu-item-->
<!--                    class="menu-button"-->
<!--                    [routerLink]="'/organizations'">-->
<!--                <mat-icon>business</mat-icon>{{ 'My_organizations' | translate }}-->
<!--            </button>-->
            <button mat-menu-item
                    class="menu-button"
                    (click)="onLogoutClicked()">
                <mat-icon>stop</mat-icon>{{ 'Disconnect' | translate }}
            </button>

            <hr class="app-version-text-separator">

            <p class="app-version-text">v{{ appVersion }}</p>
        </mat-menu>
        <button mat-mini-fab
                class="fab"
                [matTooltip]="'Language' | translate"
                [matMenuTriggerFor]="langMenu">
            <mat-icon color="primary">language</mat-icon>
        </button>

        <mat-menu #langMenu="matMenu" xPosition="before">
            <button mat-menu-item
                class="menu-button"
                *ngFor="let lang of availableLangs"
                (click)="onLangClicked(lang.id)">
            {{ lang.shortName }}
            </button>
        </mat-menu>
    </div>
</div>
